<script lang="ts">

import Tile from "../components/Tile.svelte";
import LevelButton from "../levelup/LevelButton.svelte";
import { Character, characterStore, initCharacter } from "./character";
import { calcHitPoints, calcMagicPoints } from "./fighsystem";


const tileConfig = [
	{key:"Generell", value: "commonAttributes"},
	{key:"Character Attribute",	value: "characterAttributes"},
	{key:"Wiederstand",	value: "resistance"},
	{key:"Erscheinung",	value: "appearance"},
	{key:"Level", value:  "level"},
	{key:"Defense", value: "defense" },
]

let character: Character = initCharacter()

characterStore.subscribe(c => {
	character = c
	character.fightAttributes.magic = calcMagicPoints(character)
	character.fightAttributes.hits = calcHitPoints(character)
	character.defense.basic = character.characterAttributes.re * 3 // todo: move to character.ts 
	
	console.log("Character.subscribe ", character)
})



function parseJson(value: string){
	try {
		return JSON.parse(value.trim())
	} catch (error) {
		return []
	}
}

</script>

<character>
	<h2 class="mb-4">Character</h2>		
		<div class="
			grid
			grid-cols-1 gap-4
			sm:grid-cols-2
			lg:grid-cols-3
			xl:grid-cols-4
			2xl:grid-cols-5

		">

		{#each tileConfig as {key, value}}
			<Tile 
				key={value} 
				title={key} >
			</Tile>
		{/each}

		

			<div class="
				border border-gray-300 rounded-md 
				bg-gray-100
				p-2
			">
				<h3>Magiepunkte</h3>
				<label>Verbrauchtes Mana</label>
				<input 
					type="number" 
					min=0 
					bind:value={character.fightAttributes.magic.malus} 
					on:change={() => characterStore.set(character)}>

				<label>Treffer</label>
				<div>{character.fightAttributes.magic.actual} / {character.fightAttributes.magic.total}</div>

				<label>Abzug</label>
				<div>{character.fightAttributes.magic.malusMagic}</div>
			</div>



			<div class="
				border border-gray-300 rounded-md 
				bg-gray-100
				p-2
			">
				<h3>Treffer</h3>
				<label>Verlorene Treffer</label>
				<input 
					type="number"
					min=0 
					bind:value={character.fightAttributes.hits.malus} 
					on:change={() => characterStore.set(character)}>


				<label>Todestreffer</label>
				<div>{character.fightAttributes.hits.death}</div>

				<label>Treffer</label>
				<div>{character.fightAttributes.hits.actual} / {character.fightAttributes.hits.total}</div>


				<label>Abzug</label>

				<div>{character.fightAttributes.hits.malusHit}</div>
			</div>

			<div class="
					border border-gray-300 rounded-md 
					bg-gray-100
					p-2
				">
				<h3>Progressionen</h3>

				<label>Magiepunkte</label>
				<input type="text"  bind:value={character.progressions.magicJson} 
					on:input={() => {
						const p = parseJson(character.progressions.magicJson)

						character.progressions.magicList = p;	
						characterStore.set(character)
					}}>

				<label>Koerperentwicklung</label>
				<input type="text"  bind:value={character.progressions.bodyJson} 
					on:input={() => {
						const p = parseJson(character.progressions.bodyJson)
						
						character.progressions.bodyList = p;	
						characterStore.set(character)
					}}>
			</div>
		</div>

		<LevelButton></LevelButton>
</character>
